import React, { useMemo } from "react";
import DataTable from "../_Components/DataTable";
import SwalMessage from "../_Components/SwalMessage";
import { Badge } from "react-bootstrap";
import _ from "lodash";
import ApiUserManager from "../../../core/api/api.userManager";
import Swal from "sweetalert2";
import Switch from "@mui/material/Switch";
import { Button } from "react-bootstrap";

const DataGrid = ({ data, setShowModalUser, setSelectedUserId }) => {
  const handleChange = (name) => (event) => {
    callApiService(name);
  };

  async function callApiService(item) {
    const response = await ApiUserManager.updateUserActive({ id: item.id, active: !item.active });
    if (response.succeeded == true) document.getElementById("submitButton").click();

    SwalMessage({ title: response.message, iSsuccess: response.succeeded });
  }

  const handleDelete = (item) => (event) => {
    deleteMessage(item);
  };
  async function deleteMessage(item) {
    Swal.fire({
      title: "عملیات حذف کاربر",
      text: "ایا قصد حذف این کاربر از کاربران مجموعه را دارید؟",
      showDenyButton: true,
      showCancelButton: true,
      icon: "question",
      confirmButtonText: "بله",
      denyButtonText: "خیر",
      cancelButtonText: "انصراف",
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap btn btn-secondary px-3",
        confirmButton: "order-2 btn btn-success px-5",
        denyButton: "order-3 btn btn-danger px-5",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        deleteApi(item);
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    });
  }
  async function deleteApi(item) {
    const response = await ApiUserManager.deleteUser({ id: item.id });
    if (response.succeeded == true) document.getElementById("submitButton").click();

    SwalMessage({ title: response.message, iSsuccess: response.succeeded });
  }

  const columns = useMemo(
    () => [
      {
        accessor: "_id",
        Header: "#",
        minWidth: 50,
      },
      {
        accessor: "userName",
        Header: "نام کاربری",
        minWidth: "100px",
      },
      {
        accessor: "firstName",
        Header: "نام",
        minWidth: "100px",
        // align: "center",
        // Cell: ({ row }) => (
        //     <div className="text-center">
        //         {_.toString(row.original.paymentDate)} - {_.toString(row.original.paymentTime)}
        //     </div>
        // )
      },
      {
        accessor: "lastName",
        Header: "نام خانوادگی",
        minWidth: "100px",
      },
      {
        // accessor: "roles",
        Header: "نقش ها",
        minWidth: "100px",
        Cell: ({ row }) => (
          <div className="text-center">
            {row.original.roleList.length > 0
              ? row.original.roleList?.map((itemData, index) => itemData).join(" - ")
              : "-"}
          </div>
        ),
      },
      {
        accessor: "email",
        Header: "ایمیل",
        minWidth: "100px",
      },
      {
        Header: "تایید ایمیل",
        minWidth: "100px",
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {row.original.emailConfirmed ? (
              <Badge className="text-success bg-light-success" pill>
                فعال
              </Badge>
            ) : (
              <Badge className="text-danger bg-light-danger" pill>
                غیرفعال
              </Badge>
            )}
          </div>
        ),
      },
      {
        Header: "تایید تلفن همراه",
        minWidth: "130px",
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {row.original.phoneNumberConfirmed ? (
              <Badge className="text-success bg-light-success" pill>
                فعال
              </Badge>
            ) : (
              <Badge className="text-danger bg-light-danger" pill>
                غیرفعال
              </Badge>
            )}
          </div>
        ),
      },
      {
        Header: "فعال",
        minWidth: "100px",
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            <Switch
              checked={row.original.active ? true : false}
              //checked={state.checkedA}
              value="row.original.active"
              color="primary"
              inputProps={{ "aria-label": "primary checkbox" }}
              onChange={handleChange(row.original)}
            //onChange={changeActive(row.original.id)}
            />
          </div>
        ),
      },
      {
        accessor: "lastLoginDate",
        Header: "آخرین ورود",
        minWidth: "100px",
      },
      {
        accessor: "createdPersianTime",
        Header: "زمان ایجاد",
        minWidth: "100px",
      },
      {
        Header: "عملیات",
        accessor: "",
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {/* مشاهده */}
            {/* <button
                            className="btn btn-light-info btn-sm mr-2 btn-icon"
                        >
                            <i className='far fa-eye text-small'></i>
                        </button> */}

            {/* ویرایش */}
            <Button
              className="btn btn-light-primary btn-sm mr-2 btn-icon"
              title="ویرایش"
              onClick={() => {
                setSelectedUserId(row.original.id);
                setShowModalUser(true);
              }}
            >
              <i className="far fa-edit text-small"></i>
            </Button>
            {/* <Link variant="success"
                            key={row.original.id}
                            to={{
                                pathname: `/users/addEditeModal/1`,
                                data: `id=${row.original.id}`,
                                state: { background: location },
                            }}
                            className="btn btn-light-primary btn-sm mr-2 btn-icon"
                        >
                            <i className='far fa-edit text-small'></i>
                        </Link> */}

            {/* حذف */}
            <button
              onClick={handleDelete(row.original)}
              title="حذف"
              className="btn btn-light-danger btn-sm btn-icon"
              type="button"
            >
              <i className="far fa-trash-alt text-small"></i>
            </button>
          </div>
        ),

        // Cell: ({ row }) => (
        //     <div className="text-center">
        //         {/* ویرایش */}
        //         <Link className="btn btn-light-primary btn-sm mr-2 btn-icon" to={`/userWithdrawalsDetails/${row.original.id}`}   >
        //             <i className='far fa-edit text-small'></i>
        //         </Link>
        //     </div>
        // )
      },
    ],
    [],
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
};

export default DataGrid;
